module.exports = __webpack_public_path__ + "static/media/Central_Bank_of_Armenia_Logo.db872e59.svg";